import React, { useState } from "react";
import {
  Box,
  Button,
  Textarea,
  useToast,
  HStack,
  IconButton,
  Tooltip
} from "@chakra-ui/react";
import { ArrowForwardIcon, AttachmentIcon, SmileIcon } from "@chakra-ui/icons";
import axios from "axios";

export default function SendChat({ id, to }) {
  const [message, setMessage] = useState("");
  const authToken = localStorage.getItem("authToken");
  const toast = useToast();
  const [isSending, setIsSending] = useState(false);

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (message.trim()) {
      setIsSending(true);
      try {
        const response = await axios.post(
          "https://api.agromanch.com/sendMessage",
          { message, id, to },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          setMessage("");
        } else if (response.status === 201) {
          toast({
            title: "Message not sent",
            description: "You cannot send messages to this user",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (error) {
        toast({
          title: "Error",
          description: "Failed to send message",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsSending(false);
      }
    }
  };

  return (
    <Box as="form" onSubmit={sendMessage}>
      <HStack spacing={2} align="flex-end">
        <Tooltip label="Attach file (coming soon)" placement="top">
          <IconButton
            icon={<AttachmentIcon />}
            variant="ghost"
            size="sm"
            isDisabled
            aria-label="Attach file"
          />
        </Tooltip>
        
        <Textarea
          value={message}
          onChange={handleMessageChange}
          placeholder="Type a message..."
          size="sm"
          resize="none"
          rows={1}
          borderRadius="md"
          focusBorderColor="green.400"
          maxH="100px"
          overflow="auto"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              sendMessage(e);
            }
          }}
        />
        
        <Button
          type="submit"
          colorScheme="green"
          borderRadius="full"
          size="sm"
          isDisabled={!message.trim()}
          isLoading={isSending}
          px={4}
        >
          <ArrowForwardIcon />
        </Button>
      </HStack>
    </Box>
  );
}
